import { EDisplays, EJourneys, selectDisplay } from '@/context/display';
import { useAppSelector } from '@/context/storeHooks';
import { useFieldCopy } from '@/copy';
import { EParameters, getParameters } from '@/utils/setParametersFromParams';

import { Button, EButtonType } from '../Button';

interface IDisplayButtonsProps {
    leftClick: () => void; // Todo: Remove the optional
    rightClick: () => void; // Todo: Remove the optional
    leftText?: string;
    rightText?: string;
    leftType?: EButtonType;
    rightType?: EButtonType;
    idLeftButton?: string;
    idRightButton?: string;
}

export const testId = 'display-buttons';

function DisplayButtons({
    idLeftButton,
    idRightButton,
    leftClick,
    rightClick,
    leftText,
    rightText,
    leftType = EButtonType.SECONDARY_OUTLINE,
    rightType = EButtonType.PRIMARY,
}: IDisplayButtonsProps): JSX.Element {
    // A screen that passes its own wording keeps it; the rest take the
    // partner's.
    const fields = useFieldCopy();
    const params = getParameters();

    const paramJourney = params.get(EParameters.INITIAL_JOURNEY);
    const display = useAppSelector(selectDisplay);

    return (
        // testId was exported but never applied, so nothing in the rendered tree carried
        // it and the suite's own imported constant matched nothing.
        // Each button takes an equal share of the row and reaches the edges.
        // The floor keeps a short label from collapsing into a stub, and the
        // ceiling keeps a long one from running the width of a wide embed.
        // pt-6 keeps the row clear of the last field. It is only bottom-aligned
        // when the screen is short; on a full one it would otherwise sit
        // directly against the control above it.
        <div data-testid={testId} className='_flex w-full gap-3 pt-6 pb-2'>
            {paramJourney?.toLocaleUpperCase() === EJourneys.TEST_DRIVE &&
            display === EDisplays.BASIC ? (
                <div className='flex-auto' />
            ) : (
                <div className='min-w-[104px] max-w-[260px] flex-auto'>
                    <Button
                        onClick={leftClick}
                        type={leftType}
                        id={idLeftButton}
                    >
                        <p className='text-sm'>{leftText ?? fields.backButton}</p>
                    </Button>
                </div>
            )}
            <div className='min-w-[104px] max-w-[260px] flex-auto'>
                <Button
                    onClick={rightClick}
                    type={rightType}
                    id={idRightButton}
                >
                    <p className='text-sm'>{rightText ?? fields.nextButton}</p>
                </Button>
            </div>
        </div>
    );
}

export { DisplayButtons };
